var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoscalling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FABE2C;}\r\n\t.st1{fill:#FF9100;}\r\n\t.st2{fill:#FF415B;}\r\n\t.st3{fill:#E50058;}\r\n\t.st4{fill:#405580;}\r\n\t.st5{fill:#283D66;}\r\n\t.st6{fill:#FF7C48;}\r\n\t.st7{fill:#FED843;}\r\n\t.st8{fill:#5C7099;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.5,61.1h2.9V67h-2.9V61.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65,61.1h1.5V67H65V61.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,46.5v16.1H48.8V52.3h2.9v7.3h26.6V46.5H81.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.2,46.5v16.1H65v-2.9h13.3V46.5H81.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.4,21.6h14.6v8.8H72.4V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.7,21.6h7.3v8.8h-7.3V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M75.4,24.5h8.8v5.9h-8.8V24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.7,24.5h4.4v5.9h-4.4V24.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M72.4,34.7h2.9v4.4h-2.9V34.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.1,34.7h2.9v4.4h-2.9V34.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.5,27.4v8.8H90v-8.8H69.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.7,27.4H90v8.8H79.7V27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M72.4,30.4h2.9v2.9h-2.9V30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.1,30.4h2.9v2.9h-2.9V30.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M56.1,53.8H44.4c-2.4,0-4.4-2-4.4-4.4v-1.5h20.5v1.5C60.5,51.8,58.5,53.8,56.1,53.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.6,47.9H73.9c-2.4,0-4.4-2-4.4-4.4v-1.5H90v1.5C90,46,88,47.9,85.6,47.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.6,65.5h14.8v2.9H57.6V65.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65,65.5h7.4v2.9H65V65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M50.3,24.5c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S52.7,24.5,50.3,24.5z M50.3,30.4 c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S51.1,30.4,50.3,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.6,28.9c0-2.4-2-4.4-4.4-4.4v2.9c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5v2.9 C52.7,33.3,54.6,31.3,54.6,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M57.3,30.4h-7h-7L40,45h10.3h10.3L57.3,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.3,30.4h-7V45h10.3L57.3,30.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoscalling);
export default __webpack_public_path__ + "static/media/Autoscalling.0bda78ccd198ad70459036f5b332ee03.svg";
export { ForwardRef as ReactComponent };